import FinancialBreakdown from "pages/application/opportunities/edit/financialBreakdown/FinancialBreakdown";
import LoanDetails from "pages/application/opportunities/edit/loanDetails/LoanDetails";
import OpportunitySplashPage from "pages/application/opportunities/edit/opportunitySplashPage/OpportunitySplashPage";
import Opportunities from "pages/application/opportunities/index/Opportunities";
import { EmailVerification } from "pages/auth/email-verification";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../pages/application/dashboard/Dashboard";
import CreateOpportunity from "../pages/application/opportunities/create/CreateOpportunity";
import ProposedProject from "../pages/application/opportunities/edit/proposedProject/ProposedProject";
import ChangePassword from "../pages/application/profile/changePassword/ChangePassword";
import Profile from "../pages/application/profile/Profile";
import { RequestPassword, ResetPassword, SignIn, Signup } from "../pages/auth";
import { Terms } from "../pages/website";
import AuthRoute from "./AuthRoute";
import PrivateRoute from "./PrivateRoute";

const RouteProvider = () => {
  const authRoutes = [
    {
      path: "/sign-in",
      element: <SignIn />,
    },
    {
      path: "/sign-up",
      element: <Signup />,
    },
    {
      path: "/password/request",
      index: true,
      element: <RequestPassword />,
    },
    {
      path: "/password/reset",
      index: true,
      element: <ResetPassword />,
    },
  ];
  const publicRoutes = [
    {
      path: "/terms-of-service",
      element: <Terms type={"terms"} />,
    },
    {
      path: "/privacy-policy",
      element: <Terms type={"privacy"} />,
    },
    {
      path: "/email/verify",
      element: <EmailVerification />,
    },
  ];

  const privateRoutes = [
    {
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      path: "/opportunities",
      subRoutes: [
        {
          path: "",
          index: true,
          element: <Opportunities />,
        },
        {
          path: "create",
          index: false,
          element: <CreateOpportunity />,
        },
        {
          path: ":id",
          index: false,
          subRoutes: [
            {
              path: "",
              index: true,
              element: <OpportunitySplashPage />,
            },
            {
              path: "loan-details",
              index: true,
              element: <LoanDetails />,
            },
            {
              path: "proposed-project",
              index: false,
              element: <ProposedProject />,
            },
            {
              path: "financial-breakdown",
              index: false,
              element: <FinancialBreakdown />,
            },
          ],
        },
      ],
    },
    {
      path: "/profile",
      subRoutes: [
        {
          path: "",
          index: true,
          element: <Profile />,
        },
        {
          path: "change-password",
          index: false,
          element: <ChangePassword />,
        },
      ],
    },
  ];
  return (
    <Routes>
      {authRoutes.map((route) => (
        <Route
          path={route.path}
          key={route.path}
          element={<AuthRoute>{route.element}</AuthRoute>}
        />
      ))}
      {privateRoutes.map((route) => (
        <Route
          path={route.path}
          key={route.path}
          element={
            route.element && <PrivateRoute>{route.element}</PrivateRoute>
          }
        >
          {route.subRoutes &&
            route.subRoutes.map((subRoute) => (
              <Route
                path={subRoute.path}
                key={subRoute.path}
                index={subRoute.index}
                element={
                  subRoute.element && (
                    <PrivateRoute>{subRoute.element}</PrivateRoute>
                  )
                }
              >
                {subRoute.subRoutes &&
                  subRoute.subRoutes.map((secondSubRoute) => (
                    <Route
                      path={secondSubRoute.path}
                      key={secondSubRoute.path}
                      index={secondSubRoute.index}
                      element={
                        secondSubRoute.element && (
                          <PrivateRoute>{secondSubRoute.element}</PrivateRoute>
                        )
                      }
                    />
                  ))}
              </Route>
            ))}
        </Route>
      ))}
      {publicRoutes.map((route) => (
        <Route path={route.path} key={route.path} element={route.element} />
      ))}
      <Route path="*" element={<Navigate to="/sign-in" replace />} />
    </Routes>
  );
};

export const Router = React.memo(RouteProvider);
